"use strict";
var appn;
(function (appn) {
    var designerv2;
    (function (designerv2) {
        class ToolPaneBase {
            constructor() {
            }
            init() {
                this.bindEvents();
            }
            bindEvents() {
                designerv2.canvas.bindDragIn();
            }
        }
        designerv2.ToolPaneBase = ToolPaneBase;
    })(designerv2 = appn.designerv2 || (appn.designerv2 = {}));
})(appn || (appn = {}));
